class CollectionMobileNav extends HTMLElement {
  constructor() {
    super();
    this.mobileNavTabs = document.querySelectorAll('[data-mobile-nav-tab]');
    this.mobileNavTabLinks = document.querySelectorAll('[data-mobile-nav-tab-link]');
  }

  connectedCallback() {
    this.mobileNavTabLinks.forEach(link => {
      link.addEventListener('click', () => {
        this.mobileNavTabs.forEach(tab => {
          tab.classList.remove('is-active');
        });
        this.mobileNavTabLinks.forEach(link => {
          link.classList.remove('is-active');
        });
        link.classList.add('is-active');
        const tab = document.querySelector(`[data-mobile-nav-tab="${link.dataset.mobileNavTabLink}"]`);
        tab.classList.add('is-active');
      });
    });
  }
}

customElements.define('collection-mobile-nav', CollectionMobileNav);